import React from "react";
import PageHeader from "../../components/PageHeader";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import AcademicCards from "../../components/AcademicCards";
import Staff1 from "../../image/faculty/staff1.jpg";
import Staff2 from "../../image/faculty/staff2.jpg";
import elementaryPic from "../../image/elementary.png";
import highSchoolPic from "../../image/high-school.png";
import ProgramCard from "../../components/ProgramCard";
import collegePic from "../../image/college.png";
import basicEdPic from "../../image/jmif-basic-education-group.png";
import tertiaryPic from "../../image/jmif-tertiary-group.png";
import { Helmet } from "react-helmet-async";

export default function AcademicPage() {
  return (
    <div>
      {" "}
      <Helmet>
        <title>Academic | Jamiatu Marawi Al-Islamia Foundation</title>
        <meta
          name="description"
          content="Jamiatu Marawi Al-Islamia Foundation (JMIF) fosters intellectual growth by blending Islamic values with modern education to develop future leaders and scholars."
        />
        <meta
          name="keywords"
          content="Jamiatu Marawi Al-Islamia Foundation, JMIF, Marawi School, education "
        />
        <link rel="canonical" href="https://jmif-73f1a.web.app/academics" />{" "}
        <meta
          property="og:title"
          content="Academic | Jamiatu Marawi Al-Islamia Foundation"
        />{" "}
        <meta
          name="og:description"
          content="Jamiatu Marawi Al-Islamia Foundation, JMIF, Marawi School, education "
        />
        <meta property="og:image" content={basicEdPic} />
        <meta
          property="og:url"
          content="https://jmif-73f1a.web.app/academics"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main className="">
        {/* section 1 */} {/* title page */}
        <PageHeader
          pageTitle={"ACADEMICS"}
          description={
            "Explore our programs from elementary to junior high, senior high, and college for a comprehensive education."
          }
          customize={"academics"}
        />
        {/* cards */}
        <div className="responsive-padding grid grid-cols-1 md:grid-cols-3 gap-4 py-5 relative md:-top-14">
          <AcademicCards
            navigateTo={"/academics/elementary"}
            imageSrc={""}
            imageAlt={"jmif-elementary-group-pic"}
            title={"Elementary"}
          />
          <AcademicCards
            navigateTo={"/academics/senior-high"}
            imageSrc={""}
            imageAlt={"senior-high-group-pic"}
            title={"Senior High School"}
          />
          <AcademicCards
            navigateTo={"/academics/college"}
            imageSrc={""}
            imageAlt={"College-group-pic"}
            title={"College"}
          />
        </div>
        {/* Academic Programs */}
        <div className=" responsive-padding py-10 md:py-0 md:-mt-8 mb-10">
          <h1 className="capitalize mb-5 font-montserrat font-bold text-2xl laptopSm:text-[32px] leading-4 text-text-dark">
            Academic Programs
          </h1>
          {/* academic programs cards */}
          <ProgramCard
            imageSrc={""}
            imageAlt="basic-education-group-pic"
            title="Basic Education"
            description="JMIF’s Basic Education program, from Grade 1 to Grade 12, fosters academic excellence and character development in a supportive environment. With a blend of core subjects and co-curricular activities, we encourage critical thinking, creativity, and effective communication. Our focus on values and community service nurtures leadership and social responsibility, ensuring students are well-prepared for higher education and future success."
            btnOneText="Learn More"
            btnOneLink="/academics/basic-education"
            btnTwoText="Inquire Now"
            btnTwoLink="/contactUs"
          />

          <ProgramCard
            imageSrc={""}
            imageAlt="tertiary-education-group-pic"
            title="Tertiary Education"
            description="JMIF’s Tertiary Education program offers diverse undergraduate and graduate courses, designed to equip students with the knowledge and skills needed for professional success. Our experienced faculty and innovative curriculum emphasize critical thinking, research, and practical application, preparing students to excel in the global workforce and contribute meaningfully to society."
            btnOneText="Learn More"
            btnOneLink="/academics/tertiary-education"
            btnTwoText="Inquire Now"
            btnTwoLink="/contactUs"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
